import React from 'react';
import ReactDOM from 'react-dom';

import MentionsPing from 'javascripts/onsite_pings/react/mentions_ping';
import ReadersPing from 'javascripts/onsite_pings/react/readers_ping';
import RelatedWorksPing from 'javascripts/onsite_pings/react/related_works_ping';
import MentionsRetriggerPing from 'javascripts/onsite_pings/react/mentions_retrigger_ping';
import GrantsPing from 'javascripts/onsite_pings/react/grants_ping';
import RandomMentionPing from 'javascripts/onsite_pings/react/random_mention_ping';
import ProfileHitMentionPing from 'javascripts/onsite_pings/react/profile_hit_mention_ping';
import MentionsMilestonePing from 'javascripts/onsite_pings/react/mentions_milestone_ping';
import BulkDownloadPing from './react/bulk_download_ping';
import BulkDownloadBooksPing from './react/bulk_download_books_ping';
import AbandonedCartPing from './react/abandoned_cart_ping';
import WinBackPing from './react/WinBackPing';
import UserTaggingPing from './react/user_tagging_ping';

export const onsitePings = {
  user_tagging_ping: UserTaggingPing,
  abandoned_cart_ping: AbandonedCartPing,
  mentions_view_download_research_interest: MentionsPing,
  readers: ReadersPing,
  single_work_page_related_works: RelatedWorksPing,
  mentions_retrigger_view_download_research_interest_drip:
    MentionsRetriggerPing,
  grants_reminder: GrantsPing,
  random_mention_encore: RandomMentionPing,
  profile_hit_research_interest_overlap: ProfileHitMentionPing,
  mentions_view_download_research_interest_milestone: MentionsMilestonePing,
  bulk_download: BulkDownloadPing,
  bulk_download_books: BulkDownloadBooksPing,
  win_back_ping: WinBackPing,
};

function renderOnsitePing(pagePingParams) {
  const pingRequestParams = { ...pagePingParams, subdomain_param: 'api' };
  return $.get($r.api_v0_onsite_pings_path(), pingRequestParams)
    .then((pingData) => {
      // If ping specified by backend isn't registered in OnsitePings dictionary
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line no-prototype-builtins
      if (pingData === '' || !onsitePings.hasOwnProperty(pingData.pingName)) {
        return false;
      }

      const componentName = onsitePings[pingData.pingName];
      renderPingWhenReady(componentName, pingData, pagePingParams);
      return true;
    })
    .fail((error) => {
      Kale.notify({
        collectionName: 'onsite_ping',
        eventData: {
          event: 'onsite_ping_error',
          pathname: window.location.pathname,
          hash: window.location.hash,
          href: window.location.href,
          error: error,
        },
      });
      return false;
    });
}

// Helper which adds the document.ready call to render the chosen ping
export function renderPingWhenReady(componentName, pingData, pagePingParams) {
  const containingDiv = document.getElementById('onsite-ping');

  const pingProps = {
    ...pingData.pingArgs,
    // For returning to backend which ping is being dismissed
    pingName: pingData.pingName,
  };

  $(document).ready(function () {
    ReactDOM.render(
      React.createElement(componentName, pingProps, null),
      containingDiv,
    );
    containingDiv.classList.add('visible');
    containingDiv.classList.add('ping-location-control');

    let event;
    if (typeof Event === 'function') {
      event = new Event('visible');
    } else {
      event = document.createEvent('Event');
      event.initEvent('visible', true, true);
    }
    containingDiv.dispatchEvent(event);

    createTreatment(pingData.pingName, pingData.treatmentArgs, pagePingParams);
  });
}

function createTreatment(pingName, treatmentArgs, pageArgs) {
  const treatmentParams = {
    user_treatment: {
      treatment: pingName,
      treatment_details: {
        ...treatmentArgs,
        ...pageArgs,
      },
    },
  };
  $.ajax({
    type: 'POST',
    url: $r.create_treatment_api_v0_onsite_pings_path({
      subdomain_param: 'api',
    }),
    contentType: 'application/json',
    processData: false,
    data: JSON.stringify(treatmentParams),
  });
}

export default renderOnsitePing;
